import { history } from "../store/index";
import { store } from "../../NextApp";
import { generateQueryString } from "../../util/Api";
import {
  CREATE_PAGE_SETTING_SUCCESS,
  FETCH_MASTER_FILTER_SUCCESS,
  FETCH_PAGE_SETTING_FILTER_SUCCESS,
  FETCH_PAGE_SETTING_FOR_PAGE_SUCCESS,
  FETCH_PAGE_SETTING_SUCCESS,
  GET_PAGE_SETTING_SUCCESS,
  SAVE_PAGE_SETTING_QUERY,
} from "../../constants/ActionTypes";
import axios from "util/Api";
import {
  fetchError,
  fetchFilter,
  fetchMasterFilterSuccess,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter,
} from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_PAGE_SETTING_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_PAGE_SETTING_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_PAGE_SETTING_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_PAGE_SETTING_SUCCESS,
    data,
  };
};

export const fetchResourceForPageSuccess = ({ data }) => {
  return {
    type: FETCH_PAGE_SETTING_FOR_PAGE_SUCCESS,
    data,
  };
};

export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { assetMake } = store.getState();
      const { query } = assetMake;
      console.log(query);
      const response = await axios.get(
        `/page-setting?${generateQueryString(query)}`,
      );
      console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { assetMake } = store.getState();
      const { query } = assetMake;
      const response = await axios.get(
        `/page-setting/download?columns=${columns}&${generateQueryString(query)}`,
      );
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const createResource = (
  payload,
  redirect = true,
  module,
  subMaster = false,
  superMaster = false,
) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/page-setting`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
      }
      if (!redirect) {
        if (subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if (superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push("/page-setting");
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const updateResource = (payload, id, isFromPageSetting = false) => {
  // console.log(payload, id, isFromPageSetting)
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/page-setting/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      if (!isFromPageSetting) {
        dispatch(getUser());
        history.push("/page-setting");
        dispatch(getResource());
      } else {
        message.success(`Page Setting updated`);
        setTimeout(() => window.location.reload(), 1500);
      }
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/page-setting/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const fetchResourceByPage = (page, isFromPageSetting = true) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // console.log(page)
      const response = await axios.get(`/page-setting/page/${page}`);
      // console.log(response)
      dispatch(fetchSuccess());
      if (!isFromPageSetting)
        dispatch(fetchResourceSuccess({ data: response.data }));
      else dispatch(fetchResourceForPageSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.delete(`/page-setting/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};
